import _ from "lodash";
import {
  isValuePresent,
  parsedSpacingValue,
  isSectionColumnsMobileSorted,
} from "../../utils/builderUtils";

// converts old database values to current values
const backport = (section, column) => {
    let options = { ...section.options["structure"] };

    const levelsMap = {
      0: 0,
      1: 15,
      2: 25,
      3: 40,
      4: 70,
      5: 120,
    };

    ["top", "bottom", "left", "right"].forEach((side) => {
      // desktop
      const desktopKey = "cf-column-" + column.name + "-padding-" + side;
      const desktopValue = options[desktopKey];

      if (
        desktopValue &&
        typeof desktopValue == "string" &&
        desktopValue.indexOf("_") > -1
      ) {
        let level = desktopValue.split("_").pop();
        options[desktopKey] = levelsMap[level];
      }

      // mobile
      const mobileKey = "cf-column-" + column.name + "-padding-mobile-" + side;
      const mobileValue = options[mobileKey];

      if (
        mobileValue &&
        typeof mobileValue == "string" &&
        mobileValue.indexOf("_") > -1
      ) {
        let level = mobileValue.split("_").pop();
        options[mobileKey] = levelsMap[level];
      }

      let borderWidth = options[`cf-column-${column.name}-border-width`];
      if (borderWidth && borderWidth.indexOf("px") > -1) {
        options[`cf-column-${column.name}-border-width`] = borderWidth.replace(
          "px",
          ""
        );
      }
    });

    return options;
};

export const buildSectionColumnStylesheet = (builder, device, cta, variant, section, column) => {
    let options = backport(section, column);

    let minHeight;
    if (
      builder == true &&
      device == "desktop" &&
      section.options["structure"]["browser-height"] == "true" &&
      !section.element_id &&
      (cta.cta_type == "page" ||
        ((cta.cta_type == "inline" || cta.cta_type == "overlay") &&
          variant["options"]["container-width"] == "100%"))
    ) {
      minHeight = "700px";
    }

    // background image url
    let backgroundImage = options["cf-column-" + column.name + "-background"];

    if (backgroundImage) {
      backgroundImage = backgroundImage.replace('url("', "").replace('")', "");
    }

    let borderStyle =
      _.isNil(options[`cf-column-${column.name}-border-style`]) == false
        ? options[`cf-column-${column.name}-border-style`]
        : "solid";
    let borderWidth =
      _.isNil(options[`cf-column-${column.name}-border-width`]) == false
        ? options[`cf-column-${column.name}-border-width`]
        : 0;
    let borderWidthLeft =
      _.isNil(options[`cf-column-${column.name}-border-width-left`]) == false
        ? options[`cf-column-${column.name}-border-width-left`]
        : undefined;
    let borderWidthTop =
      _.isNil(options[`cf-column-${column.name}-border-width-top`]) == false
        ? options[`cf-column-${column.name}-border-width-top`]
        : undefined;
    let borderWidthBottom =
      _.isNil(options[`cf-column-${column.name}-border-width-bottom`]) == false
        ? options[`cf-column-${column.name}-border-width-bottom`]
        : undefined;
    let borderWidthRight =
      _.isNil(options[`cf-column-${column.name}-border-width-right`]) == false
        ? options[`cf-column-${column.name}-border-width-right`]
        : undefined;

    let borderColor = options["cf-column-" + column.name + "-border-color"]
      ? options["cf-column-" + column.name + "-border-color"]
      : "#CCCCCC";

    let overlayBackgroundColor = options["cf-column-" + column.name + "-color"]
      ? options["cf-column-" + column.name + "-color"]
      : undefined;

    let overlayOpacity = options["cf-column-" + column.name + "-opacity"];

    let desktopPaddingKey = `cf-column-${column.name}-padding-`;

    let columnPosition = _.get(section, `options.structure.cf-column-${column.name}-position`);
    const columnBackgroundPosition = options[`column-${column.name}-background-position`];
    const columnCustomBackgroundTopPosition = columnBackgroundPosition == "custom" ? options[`column-${column.name}-background-custom-top-position`] : undefined;
    const columnCustomBackgroundLeftPosition = columnBackgroundPosition == "custom" ? options[`column-${column.name}-background-custom-left-position`] : undefined;

    const columnBackgroundSize = options[`column-${column.name}-background-size`];
    const columnCustomBackgroundSize = columnBackgroundSize == "custom" ? options[`column-${column.name}-background-custom-size`] : undefined;

    const columnMinHeight =
      section.options["structure"]["browser-height"] != "true" &&
      options["column-min-height"]
        ? `${options["column-min-height"]}px`
        : undefined;

    // prettier-ignore
    const desktopStyles =
`#cta_${cta.id} .cf-column[data-section-id="${section.id}"][data-column-position="${column.name}"] {
  ${minHeight ? 'min-height: ' + minHeight + ' !important;' : ''}
  ${columnMinHeight ? 'min-height: ' + columnMinHeight + ' !important;' : ''}
  ${backgroundImage ? "background-image: url(" + backgroundImage + ") !important;" : ''}
  border: initial !important;
  ${isValuePresent(borderStyle) == true ? 'border-style: ' + borderStyle + ' !important;' : ''}
  ${isValuePresent(borderWidth) == true ? 'border-width: ' + borderWidth + 'px !important;' : ''}
  ${isValuePresent(borderWidthLeft) == true ? 'border-left-width: ' + borderWidthLeft + 'px !important;' : ''}
  ${isValuePresent(borderWidthRight) == true ? 'border-right-width: ' + borderWidthRight + 'px !important;' : ''}
  ${isValuePresent(borderWidthTop) == true ? 'border-top-width: ' + borderWidthTop + 'px !important;' : ''}
  ${isValuePresent(borderWidthBottom) == true ? 'border-bottom-width: ' + borderWidthBottom + 'px !important;' : ''}
  ${borderColor ? 'border-color: ' + borderColor + ' !important;' : ''}
  padding-left: ${isValuePresent(options[desktopPaddingKey + 'left']) == true ? parsedSpacingValue(options[desktopPaddingKey + 'left']) : '0px'} !important;
  padding-right: ${isValuePresent(options[desktopPaddingKey + 'right']) == true ? parsedSpacingValue(options[desktopPaddingKey + 'right']) : '0px'} !important;
  padding-top: ${isValuePresent(options[desktopPaddingKey + 'top']) == true ? parsedSpacingValue(options[desktopPaddingKey + 'top']) : '0px'} !important;
  padding-bottom: ${isValuePresent(options[desktopPaddingKey + 'bottom']) == true ? parsedSpacingValue(options[desktopPaddingKey + 'bottom']) : '0px'} !important;
  ${isValuePresent(columnPosition) == true ? `order: ${columnPosition};` : ''}
  ${columnCustomBackgroundTopPosition ? `background-position-y: ${columnCustomBackgroundTopPosition}px !important;` : ''}
  ${columnCustomBackgroundLeftPosition ? `background-position-x: ${columnCustomBackgroundLeftPosition}px !important;` : ''}
  ${columnCustomBackgroundSize ? `background-size: ${columnCustomBackgroundSize}px !important;` : ''}
}

#cta_${cta.id} .cf-column[data-section-id="${section.id}"][data-column-position="${column.name}"] .cf-background-overlay[data-section-id="${section.id}"] {
  ${_.isNil(overlayBackgroundColor) == false ? 'background: ' + overlayBackgroundColor + ' !important;' : ''}
  ${_.isNil(overlayOpacity) == false ? 'opacity: ' + overlayOpacity + ' !important;' : ''}
}
`;

    let mobilePaddingKey = `cf-column-${column.name}-padding-mobile-`;

    let columnPositionMobile;
    if (isSectionColumnsMobileSorted(section) == true) {
      columnPositionMobile = _.get(section, `options.structure.cf-column-${column.name}-mobile-position`);
    }

    const columnBackgroundPositionMobile = options[`column-${column.name}-background-position-mobile`];
    const columnCustomBackgroundTopPositionMobile =
      columnBackgroundPositionMobile == "custom" ||
      !columnBackgroundPositionMobile && columnBackgroundPosition == "custom"
        ? options[`column-${column.name}-background-custom-top-position-mobile`]
        : undefined;

    const columnCustomBackgroundLeftPositionMobile =
      columnBackgroundPositionMobile == "custom" ||
      !columnBackgroundPositionMobile && columnBackgroundPosition == "custom"
        ? options[`column-${column.name}-background-custom-left-position-mobile`]
        : undefined;

    const columnBackgroundSizeMobile = options[`column-${column.name}-background-size-mobile`];

    const columnCustomBackgroundSizeMobile =
      columnBackgroundSizeMobile == "custom" ||
      !columnBackgroundSizeMobile && columnBackgroundSize == "custom"
        ? options[`column-${column.name}-background-custom-size-mobile`]
        : undefined;

    const columnMinHeightMobile =
      section.options["structure"]["browser-height-mobile"] != "true" &&
      options["column-min-height-mobile"] !== undefined &&
      options["column-min-height-mobile"] !== null &&
      options["column-min-height-mobile"] !== "" &&
      Number(options["column-min-height-mobile"]) > 0
        ? `${options["column-min-height-mobile"]}px`
        : undefined;

    // prettier-ignore
    const mobileStyles =
`/* mobile styles */
#cta_${cta.id} .cf-column[data-section-id="${section.id}"][data-column-position="${column.name}"] {
  ${columnMinHeightMobile ? 'min-height: ' + columnMinHeightMobile + ' !important;' : (section.options["structure"]["browser-height-mobile"] != "true" ? 'min-height: auto !important;' : '')}
  ${isValuePresent(options[mobilePaddingKey + 'left']) == true ? 'padding-left: ' + parsedSpacingValue(options[mobilePaddingKey + 'left']) + '!important;' : ''}
  ${isValuePresent(options[mobilePaddingKey + 'right']) == true ? 'padding-right: ' + parsedSpacingValue(options[mobilePaddingKey + 'right']) + '!important;' : ''}
  ${isValuePresent(options[mobilePaddingKey + 'top']) == true ? 'padding-top: ' + parsedSpacingValue(options[mobilePaddingKey + 'top']) + '!important;' : ''}
  ${isValuePresent(options[mobilePaddingKey + 'bottom']) == true ? 'padding-bottom: ' + parsedSpacingValue(options[mobilePaddingKey + 'bottom']) + '!important;' : ''}
  ${isValuePresent(options['column-' + column.name + '-background-position-mobile']) == true ? 'background-position: ' + options['column-' + column.name + '-background-position-mobile'].replace('-', ' ') + ' !important;' : ''}
  ${isValuePresent(options['column-' + column.name + '-background-size-mobile']) == true ? 'background-size: ' + (options['column-' + column.name + '-background-size-mobile'] !== 'expand-height' ? options['column-' + column.name + '-background-size-mobile'] : 'auto 100%') + ' !important;' : ''}
  ${isValuePresent(columnPositionMobile) == true ? `order: ${columnPositionMobile} !important;` : ''}
  ${columnCustomBackgroundTopPositionMobile ? `background-position-y: ${columnCustomBackgroundTopPositionMobile}px !important;` : ''}
  ${columnCustomBackgroundLeftPositionMobile ? `background-position-x: ${columnCustomBackgroundLeftPositionMobile}px !important;` : ''}
  ${columnCustomBackgroundSizeMobile ? `background-size: ${columnCustomBackgroundSizeMobile}px !important;` : ''}
}`;

    if (builder !== true) {
      return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
    } else {
      if (device == "desktop") {
        return desktopStyles;
      } else {
        return desktopStyles + mobileStyles;
      }
    }
};
